import { useTranslation } from 'react-i18next'

// The app's roles (backend auth_utils.ALLOWED_ROLES), their badge colours
// and how to name them. Shared by Administración (Personas, Cuentas) and
// anything else that shows an account's roles.

export const ROLES = [
  { value: 'admin',       descKey: 'roleDesc.admin' },
  { value: 'c_level',     descKey: 'roleDesc.c_level' },
  { value: 'pm_po',       descKey: 'roleDesc.pm_po' },
  { value: 'engineer',    descKey: 'roleDesc.engineer' },
  { value: 'purchaser',   descKey: 'roleDesc.purchaser' },
  { value: 'commercial',  descKey: 'roleDesc.commercial' },
  { value: 'operaciones', descKey: 'roleDesc.operaciones' },
  { value: 'warehouse',   descKey: 'roleDesc.warehouse' },
  { value: 'mantenimiento', descKey: 'roleDesc.mantenimiento' },
  { value: 'rrhh',        descKey: 'roleDesc.rrhh' },
]

export const ROLE_BADGE = {
  admin:      'bg-violet-100 text-violet-700',
  c_level:    'bg-indigo-100 text-indigo-700',
  pm_po:      'bg-blue-100 text-blue-700',
  engineer:   'bg-gray-100 text-gray-600',
  purchaser:  'bg-amber-100 text-amber-700',
  commercial: 'bg-emerald-100 text-emerald-700',
  operaciones:'bg-orange-100 text-orange-700',
  warehouse:  'bg-teal-100 text-teal-700',
  mantenimiento: 'bg-rose-100 text-rose-700',
  rrhh:       'bg-pink-100 text-pink-700',
}

export const roleBadge = (r) => ROLE_BADGE[r] || 'bg-gray-100 text-gray-600'

export const userRoles = (u) => Array.isArray(u.roles) && u.roles.length ? u.roles : (u.role ? [u.role] : [])

// common:roles covers admin, c_level, pm_po, engineer, purchaser, commercial;
// settings:roles the rest. Descriptions are settings:roleDesc, from ROLES
// itself so a role added there can't be left without one.
const COMMON_ROLES = ['admin', 'c_level', 'pm_po', 'engineer', 'purchaser', 'commercial']

export function useRoleText() {
  const { t } = useTranslation(['settings', 'common'])
  const roleLabel = (r) => COMMON_ROLES.includes(r)
    ? t(`common:roles.${r}`)
    : t(`settings:roles.${r}`, { defaultValue: r })
  const roleDesc = (value) => {
    const role = ROLES.find(r => r.value === value)
    return role ? t(`settings:${role.descKey}`) : ''
  }
  return { roleLabel, roleDesc }
}
